import React, { useEffect, useState } from 'react';
import { BASE_URL, DateFormat, DateTimeFormat } from '../Components/Constant';
import { Checkbox, Avatar, Card, Tag, Row, Col, Typography, message, Modal, Form, Spin, Button,Image } from 'antd';
import { PhoneOutlined, LockOutlined } from '@ant-design/icons';
import ApiService from '../Components/apiService';
import { colors, getUniqueColor, useHoverVisibility } from '../Components/Utility';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import LookupDisplayCard from './LookupDisplayCard';
import RecordDetailHeader from "./RecordDetailHeader";
import CreateRecordDrawer from './CreateRecordDrawer';
import { generateBody, formatRecordData, fetchLookupData, convertDateToUserTimezone } from '../Components/Utility';
import eventBus from '../Components/eventBus';
import { useSelector } from 'react-redux';
import isEqual from 'lodash/isEqual';
import ManualShareRecordModal from './ManualShareRecordModal';
import { Trophy } from 'lucide-react';
import ShowComponentModal from './ShowComponentModal';
import { LookupCell } from './LookupCell';
const { Title, Text } = Typography;

const CompactLayout = ({ fetchCurrency, getConvertedValue, setFunctionRef, objectid, id, objName, compactlayout, record, object, allowApprovals, fields, setRecordData, actionButtons, fetchRecordData }) => {
  const {
    isHovered,
    isVisible,
    handleMouseEnter,
    handleMouseLeave,
    handleContentMouseEnter,
    handleContentMouseLeave,
  } = useHoverVisibility();

  const [loading, setLoading] = useState(true);
  const [approvalCreated, setApprovalCreated] = useState(false);
  const [approverId, setApproverId] = useState(null);
  const [requestId, setRequestId] = useState(null);
  const [hoveredField, setHoveredField] = useState(null);
  const [isApproved, setIsApproved] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isCreateNewRecord, setIsCreateNewRecord] = useState(false);
  const [fieldsDataDrawer, setFieldsDataDrawer] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [lookupName, setLookupName] = useState('');
  const [form] = Form.useForm();
  const [selectedDate, setSelectedDate] = useState(null);
  const navigate = useNavigate();
  const [showComponentInModal, setShowComponentInModal] = useState(false);
  const userId = Cookies.get('userId');
  const userCurrency = Cookies.get('userCurrency');
  const [componentName, setComponentName] = useState('');
  const [currency, setCurrency] = useState('');
  const defaultCurrency = useSelector(state => state.data.orgItem);
  const loginUserCurrency = Cookies.get('userCurrency');
  const [currentRecord, setCurrentRecord] = useState({});
  const [isShareModalVisible, setIsShareModalVisible] = useState(false);
  const [isOwner, setIsOwner] = useState(false);
  const [objectOwd, setObjectOwd] = useState(true);
  const [canShare, setCanShare] = useState(true);
  const [initialDataForShareModal, setInitialDataForShareModal] = useState(true);
  const security = useSelector((state) => state.data.items[0]);

  const fetchOrgSetupDetails = async () => {
    setCurrency(defaultCurrency?.currency);
  };

  useEffect(() => {
    fetchCurrency();
    fetchOrgSetupDetails();
  }, []);

  useEffect(() => {
    const currentUserId = Cookies.get('userId');
    if (currentUserId === record?.user?._id) {
      setIsOwner(true);
    }
  }, [actionButtons, record]);

  const renderField = (field, fieldValue) => {
    const type = field?.type;
    switch (type) {
      case 'boolean':
        return <Checkbox checked={fieldValue} disabled />;
      case 'currency': {
        const amount = fieldValue;
        const fromCode = record?.CurrencyIsoCode;
        const toCode = loginUserCurrency;
        if (!amount) return '';
        const formattedAmount = Number(amount).toFixed(2);
        const converted = getConvertedValue(amount, fromCode, toCode);
        const original = `${fromCode} ${formattedAmount}`;
        return fromCode !== toCode ? `${original} (${toCode} ${converted})` : original;
      }
      case 'string':
        return fieldValue || '';
      case 'percentage':
        return `${fieldValue !== undefined && fieldValue !== null ? parseFloat(fieldValue) : ''}%`;
      case 'integer':
        return fieldValue !== undefined && fieldValue !== null ? fieldValue : '';
      case 'decimal':
        return fieldValue !== undefined && fieldValue !== null ? fieldValue : '';
      case 'email':
        return fieldValue ? <a href={`mailto:${fieldValue}`}>{fieldValue}</a> : '';
      case 'url':
        return fieldValue ? (
          <a href={fieldValue.startsWith('http') ? fieldValue : `http://${fieldValue}`} target="_blank" rel="noopener noreferrer">
            {fieldValue}
          </a>
        ) : '';
      case 'address':
        return fieldValue ? [fieldValue.street, fieldValue.city, fieldValue.state, fieldValue.postal_code, fieldValue.country].filter(Boolean).join(', ') : '';
      case 'lookup':

        const ob = field.parent_object_name;
        return (
          <LookupCell lookupId={fieldValue} field={field} ob={ob} />
        );
      case 'date':
        return fieldValue ? convertDateToUserTimezone(fieldValue, DateFormat) : '';
      case 'datetime':
        return fieldValue ? convertDateToUserTimezone(fieldValue, DateTimeFormat) : '';
      case 'phone':
        return fieldValue ? (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <PhoneOutlined style={{ marginRight: 6 }} />
            {fieldValue || ''}
          </div>
        ) : '';

         case 'image':
                return fieldValue ? (

                    <Image
                        src={fieldValue}
                        width={field?.image_config?.width} // Fallback to 100 if undefined
                        style={{
                            width: `${field?.image_config?.width || 100}px`,
                            height: `${field?.image_config?.height || 'auto'}px`,
                            maxWidth: `${field?.image_config?.width || 100}px`,
                            maxHeight: `${field?.image_config?.height || 'auto'}px`,
                            objectFit: 'contain' // Ensure the image fits within the defined space
                        }} // Ensure height is applied
                    />
                ) : (
                    ''
                );
      case 'multiselect':
        return Array.isArray(fieldValue) ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2px' }}>
            {fieldValue.map((value, index) => (
              <Tag key={index} color={getUniqueColor(index)} style={{ fontSize: '12px', padding: '2px 8px', borderRadius: '6px', lineHeight: '1.4' }}>
                {value}
              </Tag>
            ))}
          </div>
        ) : (fieldValue || '');
      default:
        return fieldValue || '';
    }
  };

  const getFieldType = (fieldName) => fields?.find((field) => field.name === fieldName) || null;

  useEffect(() => {
    if (record?._id) {
      fetchApprovalById();
    }
  }, [record?._id]);

  useEffect(() => {
    setFunctionRef(fetchApprovalById);
  }, [setFunctionRef]);

  const fetchApprovalById = async () => {
    try {
      const apiService = new ApiService(`${BASE_URL}/approvals/record/${record?._id}`, { "Content-Type": "application/json" }, "GET");
      const response = await apiService.makeCall();
      let pendingRequestCount = 0;
      response.forEach(item => {
        if (item.status === 'Pending') {
          pendingRequestCount++;
          setIsApproved(true);
          eventBus.emit('ApprovalCreated', 'InApproval');
          return
        }
      });
      if (pendingRequestCount === 0) {
        setIsApproved(false);
      }
    } catch (error) {
      console.error("Error fetching approval details:", error);
      setApprovalCreated(false);
    } finally {
      setLoading(false);
    }
  };

  const handleFinishFailed = (errorInfo) => {
    const { errorFields } = errorInfo;
    errorFields.forEach((field) => {
      const fieldName = field.name.join('.');
      message.error(`${fieldName} is required.`);
    });
  };

  const createApproval = async () => {
    if (approvalCreated) {
      message.error("Approval already exists for this record.");
      return;
    }

    try {
      const apiService = new ApiService(`${BASE_URL}/approvals/create/${objName}/${record?._id}`, { "Content-Type": "application/json" }, "POST");
      const response = await apiService.makeCall();
      setApprovalCreated(true);
      message.success("Approval created successfully!");
    } catch (err) {
      const errorMessage = err && typeof err === 'object'
        ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : " Error submitting approval, create approval on the object!";
      message.error(errorMessage);
    } finally {
      fetchApprovalById();
      fetchRecordData();
      setLoading(false);
    }
  };

  const handleFinish = async (values, saveAndNew = false) => {
    const updatedValues = generateBody(fieldsDataDrawer, values, (selectedRecord?._id && !selectedRecord?.isClone) ? false : true);
    if (updatedValues === "error") {
      return;
    }
    const changedValues = {};

    if (selectedRecord?._id) {
      Object.keys(updatedValues).forEach((key) => {
        const newValue = updatedValues[key];
        const oldValue = selectedRecord[key];
        const isNewKey = !(key in selectedRecord);
        const isEmpty = newValue === "" || newValue === null || newValue === undefined;
        if (!isEqual(newValue, oldValue)) {
          if (!isNewKey || (isNewKey && !isEmpty)) {
            changedValues[key] = newValue;
          }
        }
      });
      Object.keys(changedValues).forEach(key => {
        if (changedValues[key] === undefined) {
          delete changedValues[key];
        }
      });
    }

    const body = {
      object_name: objName,
      data: {
        _id: selectedRecord?._id && !selectedRecord?.isClone ? selectedRecord?._id : undefined,
        ...((selectedRecord?.isClone || !selectedRecord?._id) ? updatedValues : changedValues)
      }
    };

    try {
      const apiService = new ApiService(`${BASE_URL}/insert_or_update_records`, { 'Content-Type': 'application/json' }, 'POST', body);
      const response = await apiService.makeCall();
      message.success(selectedRecord?._id && !selectedRecord?.isClone ? 'Record updated successfully' : 'Record created successfully');
      if (!saveAndNew) {
        setDrawerVisible(false);
        form.resetFields();
        if (isCreateNewRecord) {
          navigate(`/record/${objName}/${response.id}`, { state: { response, objectid: id } });
        }
      } else {
        form.resetFields();
      }
    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to save record due to an unknown error';
      message.error(errorMessage);
    } finally {
    }
  };

  const handleEdit = async () => {
    eventBus.emit('EditModeOn');
  }

  const handleCloneClick = async () => {
    try {
      setIsCreateNewRecord(true);
      const apiServiceForFields = new ApiService(`${BASE_URL}/mt_fields/object/${objName}`, { 'Content-Type': 'application/json' }, 'GET');
      const fieldsResponse = await apiServiceForFields.makeCall();
      setFieldsDataDrawer(fieldsResponse);
      const clonedRecord = { ...record, _id: undefined, isClone: true };
      const formattedClonedRecord = await formatRecordData(clonedRecord, fieldsResponse, BASE_URL);
      setSelectedRecord(formattedClonedRecord);
      form.setFieldsValue(formattedClonedRecord);
      fetchLookupData(clonedRecord, fieldsResponse, BASE_URL, setLookupName, form);
    } catch (error) {
      console.error('Error fetching API response:', error);
    } finally {
    }

    setDrawerVisible(true);
  };

  const deleteRecord = async (record) => {
    try {
      const apiService = new ApiService(`${BASE_URL}/delete_record/${objName}/${record?._id}`, {}, 'DELETE');
      await apiService.makeCall();
      message.success('Record deleted successfully.');
      navigate(`/object/${objectid}`);
    } catch (error) {
      message.error('Failed to delete record.');
      console.error('Error deleting record:', error);
    }
  };

  const confirmDelete = async () => {
    deleteRecord(record);
    setIsDeleteModalVisible(false);
  };

  const handleButtonClick = async (button) => {
    try {
      const name = button.component_name;
      const isDownload = name?.includes("?");
      const [baseComponent, queryString] = name?.split("?");
      const params = new URLSearchParams(queryString);
      const primary_object = params.get("primary_object");
      const template_id = params.get("template_id");
      const download = params.get("download");
      const attached = params.get("attached");
      let response;
      if (download === "true" && isDownload) {
        eventBus.emit("loadingStart", "Hold on, your file is being Processed..");
        const apiService = new ApiService(`${BASE_URL}/generate_docx_new/${template_id}/${id}/${primary_object}/${download}/${attached}`, { "Content-Type": "application/json" }, "POST");
        response = await apiService.makeCall();
      }
      if (button?.type === "custom") {
        const apiService = new ApiService(`${BASE_URL}/api/classes/execute`, { "Content-Type": "application/json" }, "POST", {
          action_info: {
            class_name: button.action_info.class_name,
            method: button.action_info.method_name,
            args: button.action_info.args
          }
        });
        response = await apiService.makeCall();
      }

      if (response?.base64) {
        const byteCharacters = atob(response?.base64);
        const byteNumbers = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const blob = new Blob([byteNumbers], { type: response.file_type });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = response.file_name || "downloaded_file.docx";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        message.success("File downloaded successfully!");
        return;
      } else {
        message.error("File download failed.");
      }

      setComponentName(name);
      setShowComponentInModal(true);
    } catch (err) {
      console.error("Download or modal error", err);
      message.error("Something went wrong.");
    } finally {
      eventBus.emit("loadingEnd");
    }
  };

  const openShareModal = async (record) => {
    try {
      const apiService = new ApiService(`${BASE_URL}/manual_shares?object_name=${objName}&record_id=${record?._id}`, { "Content-Type": "application/json" }, "GET");
      const response = await apiService.makeCall();
      setInitialDataForShareModal(response);
    } catch (error) {
      console.log('error in fetching the initial data for the share record::', error);
    }
    setCurrentRecord(record);
    setIsShareModalVisible(true);
  };

  const handleShareRecordSave = async (values) => {
    try {
      const apiService = new ApiService(`${BASE_URL}/manual_shares`, { "Content-Type": "application/json" }, "POST", values);
      const response = await apiService.makeCall();
      setIsShareModalVisible(false);
    } catch (error) {
      message.error('error creating share record', error);
    } finally {
    }

  };
  const CloseSharingModal = () => {
    setIsShareModalVisible(false);
  }
  return (
    <div style={{ marginLeft: -2, padding: 2 }} // temp
    >
      {showComponentInModal && <ShowComponentModal objName={objName} recId={record._id} componentName={componentName} showComponentInModal={showComponentInModal} setShowComponentInModal={setShowComponentInModal} />}
      <Spin spinning={loading} size="medium">
        <RecordDetailHeader
          allowApprovals={allowApprovals}
          title={renderField(getFieldType(compactlayout?.title_field), record[compactlayout?.title_field])}
          buttons={
            security?.system_settings?.action_button?.view === false
              ? []
              : [
                isApproved === false && {
                  label: "Submit For Approval",
                  type: "primary",
                  onClick: createApproval,
                  loading: loading,
                  disabled: isApproved === true,
                },
                isApproved === true && {
                  label: (
                    <>
                      Record Locked
                      <LockOutlined style={{ fontSize: 16, marginLeft: 6, verticalAlign: 'middle', marginBottom: 2 }} />
                    </>
                  ),
                  type: "primary",
                  disabled: true,
                  style: {
                    backgroundColor: "#f0f0f0",
                    border: "1px solid #d9d9d9",
                    color: "rgba(0, 0, 0, 0.50)",
                    cursor: "not-allowed",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "35px",
                    padding: "0 15px",
                  },
                },
                ...(actionButtons?.length > 0
                  ? actionButtons.map((button) => ({
                    label: button.name,
                    type: "primary",
                    onClick:
                      button.name === "Edit" ? handleEdit
                        : button.name === "Clone" ? handleCloneClick
                          : button.name === "Delete" ? () => setIsDeleteModalVisible(true)
                            : () => handleButtonClick(button),
                  }))
                  : []),
              ].filter(Boolean)
          }
        />

        <Modal
          title={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "100%",
                minHeight: "20px", // ensures title area has height
              }}
            >
              Confirm Deletion
            </div>
          }
          visible={isDeleteModalVisible}
          zIndex={1002}   // higher than sidebar
          onOk={confirmDelete}
          onCancel={() => setIsDeleteModalVisible(false)}
          okText="Delete"
          cancelText="Cancel"
          centered
          bodyStyle={{
                    maxHeight: "30vh",
                    overflowY: "auto",
                    padding: "12px",
                }}
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: "16px",
                padding: "6px 0",
              }}
            >
              <Button
                onClick={() => setIsDeleteModalVisible(false)}
                style={{
                  border: "1px solid #d9d9d9",
                  borderRadius: "6px",
                  padding: "6px 16px",
                  background: "white",
                  cursor: "pointer",
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={confirmDelete}
                type="primary"
                style={{
                  border: "none",
                  borderRadius: "6px",
                  padding: "6px 16px",
                  color: "white",
                  cursor: "pointer",
                }}
              >
                Save
              </Button>
            </div>
          }
        >
          <p>Are you sure you want to delete this record?</p>
        </Modal>
        {(drawerVisible &&
          <CreateRecordDrawer
            visible={drawerVisible}
            onClose={() => setDrawerVisible(false)}
            onFinish={handleFinish}
            form={form}
            loading={loading}
            fieldsData={fieldsDataDrawer}
            selectedRecord={selectedRecord}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            handleFinishFailed={handleFinishFailed}
          />
        )}
        <Card style={{ borderRadius: 7, marginTop: 48, marginLeft: 0, padding: 'auto', boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }} bodyStyle={{ padding: 14 }}>
          <Row gutter={8}>
            {compactlayout?.layout_fields?.map((field) => {
              const matchedfield = getFieldType(field.field_name);
              const columnSpan = 4

              return (
                <Col span={columnSpan} key={field.order} style={{ marginBottom: 6, marginTop: 6 }}>
                  <Text style={{ fontSize: 14 }} strong>
                    {field.display_label}
                  </Text>
                  <br />
                  <Text>
                    {renderField(matchedfield, record[field.field_name])}
                  </Text>
                </Col>
              );
            })}
          </Row>
        </Card>
      </Spin>
    </div>
  );
};

export default CompactLayout;